import { Carousel } from 'bootstrap'

const myCarousel = document.getElementById('letterine-carousel');
if (myCarousel) {
    const carousel = new Carousel(myCarousel, {
        interval: 2000
    })
    document.addEventListener("scroll", (event) => {
        var carousel = Carousel.getInstance(myCarousel)
        if (window.scrollY > carousel._element.offsetTop) {
            carousel.pause()
        } else {
            carousel.cycle()
        }
    })
}
